import { wecomAccountWsClient, wecomChatWsClient } from "../request";
import {
  ChannelTypeEnum,
  ChatType,
  WS_REQUEST_MESSAGE_TYPE,
  ServiceType,
  WecomContactType,
} from "../types";

/**
 * 打开客户端
 */
const sendOpenClientCommand = (params: {
  team_id: string;
  user_id: string;
  service_type: ServiceType;
  client_id?: number;
  ip?: string;
  request_key?: string;
  /** 同步离线期间最新消息 */
  fetch_history_msg?: boolean;
}) => {
  const {
    team_id,
    fetch_history_msg,
    user_id,
    service_type,
    client_id,
    ip,
    request_key,
  } = params;
  return wecomAccountWsClient.sendMessage({
    message_type: WS_REQUEST_MESSAGE_TYPE.OPEN,
    channel_type: ChannelTypeEnum.Wecom,
    service_type,
    ip,
    client_id,
    user_id,
    data:
      fetch_history_msg !== void 0
        ? {
            teamId: team_id,
            fetchHistoryMsg: fetch_history_msg,
          }
        : { teamId: team_id },
    request_key,
  });
};

/**
 *
 * 验证登录请求
 */
export type SendVerifyVerificationParams = {
  login_verify_code: string; // 手机端的验证码
  login_qrcode_key: string;
  request_key: string;
};
const sendVerifyVerificationCommand = (
  from_user_id: string,
  serviceType: ServiceType,
  data: SendVerifyVerificationParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  return wecomAccountWsClient.sendMessage({
    user_id: from_user_id,
    message_type: WS_REQUEST_MESSAGE_TYPE.VERIFY_VERIFICATION_CODE,
    channel_type: ChannelTypeEnum.Wecom,
    data,
    service_type: serviceType,
    request_key,
  });
};

/**
 * 发送文本消息
 */
export type WecomSendTextParams = {
  content: string;
  to_id: string;
  chat_type: WecomContactType;
  request_key: string;
};
const sendTextCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WecomSendTextParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_TEXT,
    channel_type: ChannelTypeEnum.Wecom,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wecomChatWsClient.sendMessage(params);
};

/**
 * 发送文本混合消息
 */
export type WecomSendTextMixedParams = {
  content: {
    subtype: number;
    text: string;
  }[];
  to_id: string;
  chat_type: WecomContactType;
  request_key: string;
};
const sendTextMixedCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WecomSendTextMixedParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_TEXT_MIXED,
    channel_type: ChannelTypeEnum.Wecom,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wecomChatWsClient.sendMessage(params);
};

export type WecomSendImageParams = {
  to_id: string;
  chat_type: WecomContactType;
  request_key: string;
  path: string;
};
const sendImageCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WecomSendImageParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_IMAGE,
    channel_type: ChannelTypeEnum.Wecom,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wecomChatWsClient.sendMessage(params);
};
// 发送视频
export type WecomSendVideoParams = {
  to_id: string;
  chat_type: WecomContactType;
  request_key: string;
  path: string;
};
const sendVideoCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WecomSendVideoParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_VIDEO,
    channel_type: ChannelTypeEnum.Wecom,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wecomChatWsClient.sendMessage(params);
};

// 发送视频号
export type WecomSendVideoNumParams = {
  to_id: string;
  chat_type: WecomContactType;
  username: string;
  channel_name: string;
  channel_url: string;
  head_img_url: string;
  thumb_url: string;
  encode_data: string;
  request_key: string;
};
const sendVideoNumCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WecomSendVideoNumParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_VIDEO_NUM,
    channel_type: ChannelTypeEnum.Wecom,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wecomChatWsClient.sendMessage(params);
};

// 发送文件
export type WecomSendFileParams = {
  to_id: string;
  chat_type: WecomContactType;
  request_key: string;
  path: string;
};
const sendFileCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WecomSendFileParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_FILE,
    channel_type: ChannelTypeEnum.Wecom,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wecomChatWsClient.sendMessage(params);
};
// 发送gif

export type WecomSendGifParams = {
  to_id: string;
  chat_type: WecomContactType;
  request_key: string;
  path: string;
};
const sendGifCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WecomSendGifParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_GIF,
    channel_type: ChannelTypeEnum.Wecom,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wecomChatWsClient.sendMessage(params);
};
// 发送链接消息
export type WecomSendLinkParams = {
  to_id: string;
  chat_type: WecomContactType;
  desc: string;
  request_key: string;
  thumburl: string;
  title: string;
  url: string;
};
const sendLinkCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WecomSendLinkParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_LINK,
    channel_type: ChannelTypeEnum.Wecom,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wecomChatWsClient.sendMessage(params);
};

export type WecomSendMiniProgramParams = {
  request_key: string;
  appid: string;
  to_id: string;
  chat_type: WecomContactType;
  cover_file_aeskey: string;
  cover_file_id: string;
  cover_file_md5: string;
  cover_file_size: number;
  desc: string;
  pagepath: string;
  thumburl: string;
  username: string;
};
const sendMiniProgramCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WecomSendMiniProgramParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_MINI_PROGRAM,
    channel_type: ChannelTypeEnum.Wecom,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wecomChatWsClient.sendMessage(params);
};

// 发送好友卡片
export type WecomSendBusinessCardParams = {
  shared_id: string;
  to_id: string;
  chat_type: WecomContactType;
  request_key: string;
};
const sendBusinessCardCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WecomSendBusinessCardParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_BUSINESS_CARD,
    channel_type: ChannelTypeEnum.Wecom,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wecomChatWsClient.sendMessage(params);
};

// 发送语音
export type WecomSendVoiceParams = {
  to_id: string;
  chat_type: WecomContactType;
  duration_time: number;
  file_aeskey: string;
  file_id: string;
  file_size: number;
  request_key: string;
};
const sendVoiceCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WecomSendVoiceParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_VOICE,
    channel_type: ChannelTypeEnum.Wecom,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wecomChatWsClient.sendMessage(params);
};

// 撤回消息
type SendRevocationMessageParams = {
  msg_unique_identifier: string;
  request_key: string;
  msg_server_id: string;
  to_id: string;
  chat_type: ChatType;
  sender_id: string;
};
const sendRevocationMessageCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: SendRevocationMessageParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.REVOCATION_MESSAGE,
    channel_type: ChannelTypeEnum.Wecom,
    service_type,
    data,
    user_id: from_user_id,
    request_key,
  };
  return wecomChatWsClient.sendMessage(params);
};

const WecomCommand = {
  sendOpenClientCommand,
  sendVerifyVerificationCommand,
  sendTextCommand,
  sendTextMixedCommand,
  sendImageCommand,
  sendVideoCommand,
  sendVideoNumCommand,
  sendFileCommand,
  sendGifCommand,
  sendLinkCommand,
  sendMiniProgramCommand,
  sendBusinessCardCommand,
  sendVoiceCommand,
  sendRevocationMessageCommand,
};
export default WecomCommand;
